export const SETTINGS_FETCH_REQUESTED = 'SETTINGS_FETCH_REQUESTED'
export const SETTINGS_FETCH_SUCCESS = 'SETTINGS_FETCH_SUCCESS'
